module.exports = __webpack_public_path__ + "img/georgia.6e913f6d.jpg";